import { render, staticRenderFns } from "./ItemSoldToWindow.vue?vue&type=template&id=bdd2bb76&"
import script from "./ItemSoldToWindow.vue?vue&type=script&lang=js&"
export * from "./ItemSoldToWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports